import {useLayoutEffect} from 'react';

// https://twitter.com/kentcdodds/status/1610305138278924288
export const useLayoutEffectIsomorphic = typeof window !== 'undefined' ? useLayoutEffect : () => {};
